import React from "react";

import { IEditFavoriteBtn } from "../@types";
import TooltipButton from "../TooltipButton";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const EditFavoriteQueryBtn = ({ onClick }: IEditFavoriteBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.EDIT_FAVOURITE })}
    type="favorite-added"
    label="Edit favorite query"
  />
);
